import { forwardRef, SVGProps } from "react";

const ShareIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function ShareIcon(props, ref) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        {...props}
        ref={ref}
      >
        <path
          fill="currentColor"
          d="M14.333 18c-.74 0-1.37-.262-1.889-.788a2.62 2.62 0 0 1-.777-1.912c0-.09.022-.3.066-.63L5.49 10.98a2.639 2.639 0 0 1-.822.53 2.594 2.594 0 0 1-1 .19 2.56 2.56 0 0 1-1.89-.787A2.62 2.62 0 0 1 1 9c0-.75.26-1.388.778-1.912A2.556 2.556 0 0 1 3.667 6.3a2.647 2.647 0 0 1 1.822.72l6.244-3.69a1.53 1.53 0 0 1-.055-.303 4.855 4.855 0 0 1-.011-.327c0-.75.259-1.388.777-1.913A2.556 2.556 0 0 1 14.334 0c.74 0 1.37.263 1.888.787A2.62 2.62 0 0 1 17 2.7c0 .75-.26 1.388-.778 1.912a2.556 2.556 0 0 1-1.889.788 2.647 2.647 0 0 1-1.822-.72L6.267 8.37c.03.105.048.206.056.304a5.376 5.376 0 0 1 0 .652c-.007.1-.026.2-.056.304l6.244 3.69a2.625 2.625 0 0 1 1.822-.72c.741 0 1.37.263 1.89.787A2.62 2.62 0 0 1 17 15.3c0 .75-.26 1.387-.778 1.912a2.556 2.556 0 0 1-1.889.788Z"
        />
      </svg>
    );
  },
);

export default ShareIcon;
